import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type Common = {
  label: string;
  icon: ReactNode;
  testId: string;
  isMobile: boolean;
  onClick?: () => void;
};

type ExternalHref = Common & { href: string };
type InternalTo = Common & { to: string };

export type FloatingCTAButtonProps = ExternalHref | InternalTo;

function hasHref(props: FloatingCTAButtonProps): props is ExternalHref {
  return 'href' in props;
}

export function FloatingCTAButton(props: FloatingCTAButtonProps) {
  const { label, icon, testId, isMobile } = props;
  const className = isMobile
    ? 'floating-cta-actions__btn floating-cta-actions__btn--mobile'
    : 'floating-cta-actions__btn';

  const content = (
    <>
      <span className="floating-cta-actions__icon">{icon}</span>
      <span className="floating-cta-actions__label">{label}</span>
    </>
  );

  if (hasHref(props)) {
    return (
      <a
        href={props.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        data-testid={testId}
        className={className}
        onClick={props.onClick}
      >
        {content}
      </a>
    );
  }

  return (
    <Link to={props.to} aria-label={label} data-testid={testId} className={className}>
      {content}
    </Link>
  );
}
